import { createSelector } from "reselect";
import { AppState } from "app/shared/store/root.reducer";

const getStatement = (state: AppState) => state.statement;
// Lấy dữ liệu xuất sổ phụ
const getResStatementBackup = (state: AppState) => state.statement.responseStatementBackup;
const getStatusResStatementBackup = (state: AppState) => state.statement.statusResponseStatementBackup;
const getErrorResStatementBackup = (state: AppState) => state.statement.errorResponseStatementBackup;

const getResStatementV2 = (state: AppState) => state.statement.responseStatementV2;

const getResStatementDetail = (state: AppState) => state.statement.responseStatementDetail;
const getStatusStatementDetail = (state: AppState) => state.statement.statusStatementDetail;
const getErrorStatementDetail = (state: AppState) => state.statement.errorStatementDetail;

const getPending = (state: AppState) => state.statement.pending;

export const getStatementSelector = createSelector(getStatement, (data) => data);

export const getResStatementV2Selector = createSelector(getResStatementV2, (data) => data);
export const getPendingStatementSelector = createSelector(getPending, (status) => status);

// Chi tiet lich su giao dich
export const getStatusStatementDetailSelector = createSelector(getStatusStatementDetail, (status) => status);
export const getResStatementDetailSelector = createSelector(getResStatementDetail, (data) => data);
export const getErrorStatementDetailSelector = createSelector(getErrorStatementDetail, (error) => error);

// Selector lấy dữ liệu xuất sổ phụ
export const getResStatementBackupSelector = createSelector(getResStatementBackup, (data) => data);
export const getStatusResStatementBackupSelector = createSelector(getStatusResStatementBackup, (status) => status);
export const getErrorResStatementBackupSelector = createSelector(getErrorResStatementBackup, (error) => error);
